export type ImportDomainsActionResult =
  | { success: true; count: number }
  | { error: string };

export const isImportDomainsSuccess = (
  result: ImportDomainsActionResult,
): result is { success: true; count: number } => "success" in result;
